import { render, staticRenderFns } from "./PersonaForm.vue?vue&type=template&id=1b35c5dc&scoped=true"
import script from "./PersonaForm.vue?vue&type=script&lang=js"
export * from "./PersonaForm.vue?vue&type=script&lang=js"
import style0 from "./PersonaForm.vue?vue&type=style&index=0&id=1b35c5dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b35c5dc",
  null
  
)

export default component.exports